var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "375",
      "flat": "",
      "outlined": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": require("@/assets/undraw_female_avatar_w3jk.svg"),
      "alt": _vm.user.lastName,
      "height": "300px",
      "dark": ""
    }
  }, [_c('v-row', {
    staticClass: "fill-height"
  }, [_c('v-card-title', [_c('v-spacer')], 1), _c('v-spacer'), _c('v-card-title', {
    staticClass: "white--text pl-12 pt-12"
  }, [_c('div', {
    staticClass: "display-1 pl-12 pt-12"
  }, [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))])])], 1)], 1), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-phone")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$helpers.showValueWithDefault(_vm.contact.phone, "")))]), _c('v-list-item-subtitle', [_vm._v("Telefon")])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-email")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$helpers.showValueWithDefault(_vm.contact.email)))]), _c('v-list-item-subtitle', [_vm._v("Email")])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-map-marker")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$helpers.showValueWithDefault(_vm.address.street)) + " ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.$helpers.showValueWithDefault(_vm.address.city)) + " " + _vm._s(_vm.$helpers.showValueWithDefault(_vm.address.zip)) + " ")]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$helpers.showValueWithDefault(_vm.address.state)))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("mdi-shield-key-outline")])], 1), _c('v-list-item-title', [_c('a', {
    on: {
      "click": _vm.goToPermissions
    }
  }, [_vm._v("Rollen und Berechtigungen")])])], 1)], 1), _c('v-card-actions', [_c('v-btn', {
    staticClass: "ml-5 pb-2 pt-2",
    attrs: {
      "text": "",
      "icon": ""
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v(" Edit "), _c('v-icon', [_vm._v("mdi-pencil")])], 1), _c('v-spacer'), _c('v-btn', {
    staticClass: "mr-1 pb-2 pt-2",
    attrs: {
      "text": "",
      "color": "red"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(" Logout ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }